import type { ReactNode } from "react"

/** Application UI "form layout, labels on the left": a titled section of label/field rows. */
export function FormSection({ title, description, children }: { title: string; description?: string; children: ReactNode }) {
  return (
    <section>
      <h2 className="text-base/7 font-semibold text-ink-display">{title}</h2>
      {description && <p className="mt-1 max-w-2xl text-sm/6 text-ink-muted">{description}</p>}
      <div className="mt-8 space-y-8 border-b border-hairline pb-12 sm:space-y-0 sm:divide-y sm:divide-hairline sm:border-t sm:border-hairline sm:pb-0">
        {children}
      </div>
    </section>
  )
}

export function FormRow({
  label,
  htmlFor,
  hint,
  hintId,
  children,
}: {
  label: string
  htmlFor?: string
  hint?: string
  /** Gives the hint an id so a field can point at it with aria-describedby. */
  hintId?: string
  children: ReactNode
}) {
  return (
    <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
      <label htmlFor={htmlFor} className="block text-sm/6 font-medium text-ink-display sm:pt-1.5">
        {label}
      </label>
      <div className="mt-2 sm:col-span-2 sm:mt-0">
        {children}
        {hint && (
          <p id={hintId} className="mt-3 text-sm/6 text-ink-muted">
            {hint}
          </p>
        )}
      </div>
    </div>
  )
}
